export default "__VITE_ASSET__DBmxYinv__"